import { render, staticRenderFns } from "./LogoManager.vue?vue&type=template&id=7dedbb94&"
import script from "./LogoManager.vue?vue&type=script&lang=ts&"
export * from "./LogoManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports